// A readable "Chrome on macOS" from a raw user agent; the raw string stays in
// the tooltip. Deliberately small — enough to tell devices apart in an audit.
export const describeUserAgent = (userAgent: string | null | undefined): string => {
  if (!userAgent) {
    return "—";
  }

  const browser = /Edg\//.test(userAgent)
    ? "Edge"
    : /OPR\/|Opera/.test(userAgent)
      ? "Opera"
      : /Firefox\//.test(userAgent)
        ? "Firefox"
        : /Chrome\//.test(userAgent) || /CriOS\//.test(userAgent)
          ? "Chrome"
          : /Safari\//.test(userAgent)
            ? "Safari"
            : null;
  const os = /Windows/.test(userAgent)
    ? "Windows"
    : /iPhone|iPad|iPod/.test(userAgent)
      ? "iOS"
      : /Android/.test(userAgent)
        ? "Android"
        : /Mac OS X|Macintosh/.test(userAgent)
          ? "macOS"
          : /Linux/.test(userAgent)
            ? "Linux"
            : null;

  return [browser, os].filter(Boolean).join(" · ") || userAgent.slice(0, 40);
};
